<template>
  <section id="projects" class="projects">
    <section :id="'project-' + (index + 1)" v-bind:class="(index < 1) ? 'project hero' : 'project'" v-for="(project, index) in projects">

      <section-background :clazz="'background__project-' + (index + 1)"/>

      <div v-if="(index < 1)" class="container hero__container text-white">
        <div class="row d-flex flex-column">
          <h1 class="hero__title text-uppercase">Vitrix software</h1>
          <p class="hero__subtitle text-uppercase">Software <span class="text-yellow" id="typewriter">{{text}}</span></p>
          <p class="hero__text mt-4">Making professional solutions since 2017.</p>
        </div>
      </div>

      <aside v-if="(index < 1)" class="hero__aside">
        <a class="hero__contact link-to-anchor" href="#contact">Contact</a>
      </aside>

      <aside v-if="(index > 0)" class="project__number">
        <p>Project 00{{index}}</p>
      </aside>

      <div v-if="(index > 0)" class="container-fluid project__container text-white">
        <div class="row d-flex flex-column" :class="{'d-flex align-items-end': project.textRight}">
          <h2 class="project__title">{{project.headline}}</h2>
          <p class="project__description mt-4" v-html="project.text"></p>
        </div>
      </div>

      <!--<aside v-if="(index > 0)" class="project__link">-->
        <!--<a :href="project.link" target="_blank">Check project</a>-->
      <!--</aside>-->

    </section>
  </section>
</template>

<script>

  import ScrollReveal from 'scrollreveal'
  import backgroundComponent from './background'

  const sr = ScrollReveal();

  export default {
    name: 'Projects-area',
    components: {
      'sectionBackground': backgroundComponent
    },
    data() {
      return {
        //  Text should not contain Czech specific symbols
        text: '',
        texts: [
          'for the future',
          'for the humans',
          'for you'
        ],
        projects: [
          {
            headline: '',
            text: ``,
            link: ''
          },
          {
            headline: 'Realtime monitoring systems',
            text: `Monitor your dislocated infrastructure with ease. We build custom monitoring systems with great user interface.
                   <a class="link-to-anchor" href="#contact">Contact</a> us for more information.`,
            link: '' // link: 'http://www.rexy.cz'
          },
          {
            headline: 'Remote devices management',
            textRight: true,
            text: `Do you need a custom management access for your infrastructure? We have a working WEB based reverse shell solution.
                   <a class="link-to-anchor" href="#contact">Contact</a> us for more information.`,
            link: ''
          },
          {
            headline: 'Scalable cloud processing platform',
            text: `We can distribute your large data processing across multiple servers
                   to reduce load on your front-end servers without compromising user experience.
                   <a class="link-to-anchor" href="#contact">Contact</a> us for more information.`,
            link: ''
          }
        ]
      }
    },
    mounted() {
      sr.reveal('.project__title');

      let app = document.getElementById('typewriter');

      let typewriter = new Typewriter(app, {
        loop: true,
        cursor: '_'
      });

      typewriter
        .typeString(this.texts[0])
        .pauseFor(2500)
        .deleteAll()
        .typeString(this.texts[1])
        .pauseFor(2500)
        .deleteAll()
        .typeString(this.texts[2])
        .pauseFor(2500)
        .deleteAll()
        .start();
    }
  }
</script>

<style lang="scss">
  @import "../styles/custom";

  .hero {
    $title-size: 128px;
    $subtitle-size: 64px;
    position: relative;
    min-height: 100vh;
    background: no-repeat fixed center;
    background-size: cover;
    overflow-x: hidden;

    @include mobile {
      padding: 75px 0;
    }

    &__container {
      padding-top: 150px;
      position: relative;
      z-index: 20;

      @include mobile{
        padding: 0 30px;
      }
    }

    &__title {
      font-size: $title-size;
      line-height: $title-size;

      @include mobile {
        font-size: $title-size / 2;
        line-height: $title-size / 2;
      }

    }

    &__subtitle {
      font-size: $subtitle-size;
      line-height: $subtitle-size;

      @include mobile {
        font-size: $subtitle-size / 2;
        line-height: $subtitle-size / 2;
      }

    }

    &__text {
      font-size: 24px;
      text-align: right;

      @include mobile {
        font-size: 12px;
      }
    }

    //  Contact aside wrapper
    &__aside {
      position: absolute;
      z-index: 20;
      top: 50%;
      left: 0;
      transform: rotate(90deg) translateX(-25%) translateY(125%);

      @include mobile {
        position: relative;
        transform: rotate(0) translateX(0) translateY(0);
        display: flex;
        justify-content: center;
        padding-top: 10vh;
      }
    }

    //  Contact link
    &__contact {
      color: $yellow;
      font-size: 32px;
      line-height: 32px;
      text-transform: uppercase;

      &:hover {
        color: darken($yellow, 20%);
        text-decoration: none;
      }
    }
  }

  .project {
    position: relative;
    min-height: 100vh;
    background: no-repeat fixed center;
    background-size: cover;
    overflow: hidden;

    @include mobile {
      padding: 75px 0;
    }

    &__container {
      padding: 150px 128px;
      position: relative;
      z-index: 20;

      @include mobile{
        padding: 0 30px;
      }
    }

    &__description {
      max-width: 620px;
      font-size: 30px;

      @include mobile {
        font-size: 15px;
      }

      a {
        color: $yellow;

        &:hover {
          color: darken($yellow, 20%)
        }
      }
    }

    &__title {
      font-size: 86px;

      @include mobile {
        font-size: 43px;
      }
    }

    &__link {
      position: absolute;
      z-index: 20;
      top: 75%;
      left: 0;
      transform: rotate(90deg) translateX(-25%) translateY(225%);

      @include mobile {
        position: relative;
        transform: rotate(0) translateX(0) translateY(0);
        display: flex;
        justify-content: center;
        margin-top: 2rem;
      }

      a {
        text-transform: uppercase;
        font-size: 32px;
        line-height: 32px;
        color: #fff;
        text-decoration: none;
        position: relative;
        transition: .2s ease;

        &::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 100%;
          width: 64px;
          height: 3px;
          background-color: #fff;
          transition: .2s ease;
          transform: translateY(-50%);
        }

        @include mobile {
          font-size: 16px;
          line-height: 16px;

          &::after {
            height: 2px;
            bottom: -1px;
            width: 32px;
          }
        }
      }

      &:hover a {
        color: $yellow;
        &::after {
          background-color: $yellow;
        }
      }
    }

    &__number {
      z-index: 20;
      color: #fff;
      position: absolute;
      top: 75%;
      right: 0;
      font-size: 32px;
      line-height: 32px;
      text-transform: uppercase;
      transform: rotate(90deg) translateY(-100%) translateX(50%);

      @include mobile {
        position: relative;
        transform: rotate(0) translateX(0) translateY(0);
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectsArea.vue